import React from 'react';
import { useSelector } from 'react-redux';
import { pick } from 'ramda';

import { usePortletConfig } from '@core/js/components/system/Portlet';

import { useUserSelector } from '@core/js/store/hooks';

import { selectIsScheduleLoaded } from '@interlayer/js/custom/components/main/BingoScheduler/store/selectors';

import style from '../BingoScheduler.scss';

interface UserPortletConfig {
    titles?: Record<string, string>;
}

const BingoSchedulerTitle = () => {
    const { lang } = useUserSelector(pick(['lang'])) as Record<string, string>;
    const isScheduleLoaded = useSelector(selectIsScheduleLoaded);
    const { titles }: UserPortletConfig = usePortletConfig() || {};

    if (!isScheduleLoaded || !(lang && titles?.[lang])) {
        return null;
    }

    return (
        <div className={style.title_wrapper}>
            <span className={style.title}>{titles?.[lang]}</span>
        </div>
    );
};

export default BingoSchedulerTitle;
